import {
  IGeometryModel,
  MarkerModelBase,
} from '@types-custom/models/business/marker.model';
import { Icon } from '@types-custom/models/ui/icon-model';

export enum SituationTypeEnum {
  incidente_abierto = <any>'Incidente Abierto',
  incidente_cerrado = <any>'Incidente Cerrado',
  incidente_programado = <any>'Incidente Programado',
  evento_abierto = <any>'Evento Abierto',
  evento_cerrado = <any>'Evento Cerrado',
  evento_programado = <any>'Evento Programado',
}

export interface IPropsSituationsModel {
  id: number;
  situationType: string;
  creationDate: string;
  eventDate: string;
  status: string;
  title: string;
  markerPopupText: string;
  icon: Icon;
  location:string;
  category: string;
  subcategory: string;
  priority: string;
  postalcode: string;
  source: string;
  mediaName: string;
  situationName: string;
  observations: string;
  observationsAuthor: string;
}

export class SituationsModel extends MarkerModelBase {
  static className = 'SituationsModel';
  classProperties: IPropsSituationsModel;

  constructor(props: IPropsSituationsModel, geometry: IGeometryModel) {
    super(geometry, SituationsModel.className);
    this.classProperties = props;
  }
}

export enum SituationTypeFilterEnum {
  Incidente = '334',
  Evento = '335',
}
export enum SituationStateFilterEnum {
  Abierto = '331',
  Cerrado = '332',
  Programado = '333',
}
export enum SituationPriorityFilterEnum {
  Alta = '316',
  Media = '317',
  Baja = '318',
}

export enum SituationCategoryFilterEnum {
  "Accidente" = '1',
  "Obstrucción de infraestructura dañada" = '11',
  "Obstrucción ambiental" = '26',
  "Obstrucción por presencia animal" = '45',
  "Obstrucción general" = '51',
  "Obstrucción vehicular" = '76',
  "Tráfico anormal" = '105',
  "Condiciones de la situación" = '112',
  "Condiciones de la carretera no relacionadas con el clima" = '113',
  "Condiciones Ambientales" = '125',
  "Situación en Carretera" = '177',
  "Situación Gestión de la Velocidad" = '208',
  "Situación mensaje a ciudadano" = '216',
  "Situación Gestión de red" = '256',
  "Situación obras en construcción" = '266',
  "Situación Obras Mantenimiento" = '272',
}
